// react
import { List, Map } from "immutable";
// dependencies
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import Modal from "../../../components/Modals/Wrapper";
// components
import Folder from "./components/Folder";

// containers
import Curtain from "../../../containers/PageCurtain";

// actions
import { fetchSignatureTemplates } from "./actions";

import { getSignatureTemplates } from "../../../selectors/documents";
// selectors
import { getRequests } from "../../../selectors/requests";

// utils
// style
import "./style.scss";

/**
 * <DocumentsModalComponent /> is a redux-connected component. It is connected
 * to the redux store so it can dispatch document searching and read the
 * documents directly from the store.
 */
export class DocumentsModalComponent extends React.Component {
	static propTypes = {
		curtainPortalRoot: PropTypes.string,
		onClose: PropTypes.func.isRequired,
		onPick: PropTypes.func.isRequired,
		fetchSignatureTemplates: PropTypes.func.isRequired,
		requests: PropTypes.instanceOf(Map).isRequired,
		signatureTemplates: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {
		curtainPortalRoot: undefined,
	};

	state = {};

	toggleFolder = (folderID) => {
		const isCurrentlyOpen = this.state[folderID] === true;

		if (!isCurrentlyOpen && folderID === "signature-templates") {
			this.props.fetchSignatureTemplates();
		}

		this.setState({ [folderID]: !isCurrentlyOpen });
	};

	handleFileClick = (documentID) => {
		this.props.onPick(documentID);
	};

	checkRequest = (requestName) => {
		const request = this.props.requests.get(requestName, Map());
		const requestSent = moment.isMoment(request.getIn(["sent"], null));
		const requestReceived = moment.isMoment(request.getIn(["received"], null));

		return requestSent && !requestReceived;
	};

	render() {
		const { signatureTemplates, curtainPortalRoot } = this.props;

		const folders = [
			{
				label: "Signature Templates",
				id: "signature-templates",
				requestName: "SIGNATURETEMPLATES:GET",
				files: signatureTemplates,
			},
		];

		return (
			<Curtain portalRoot={curtainPortalRoot} color="black" onClose={this.props.onClose}>
				<Modal>
					<div className="modal-documents-directory">
						{folders.map((folder) => {
							const isOpen = this.state[folder.id] === true;

							return (
								<Folder
									id={folder.id}
									key={folder.id}
									isOpen={isOpen}
									label={folder.label}
									files={folder.files}
									onClick={this.toggleFolder}
									onFileClick={this.handleFileClick}
									isRequesting={this.checkRequest(folder.requestName)}
								/>
							);
						})}
					</div>
				</Modal>
			</Curtain>
		);
	}
}

const mapStateToProps = (state) => ({
	requests: getRequests(state),
	signatureTemplates: getSignatureTemplates(state),
});

const mapDispatchToProps = (dispatch) => ({
	fetchSignatureTemplates: () => dispatch(fetchSignatureTemplates()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsModalComponent);
